import type { IComponentController, ITimeoutService } from 'angular';
import template from './dashboard-configuration-panel.component.html';
import type { WidgetInstance } from '../dashboard.service';
import { DashboardPageComponent, DashboardPageController } from '../dashboard-page/dashboard-page.component';

export class DashboardConfigurationPanelController implements IComponentController {
	static readonly $inject = ['$timeout'];

	constructor(private readonly $timeout: ITimeoutService) {}

	page!: DashboardPageController;

	private highlightTimer: ReturnType<ITimeoutService> | null = null;

	onShow(widgetInstance: WidgetInstance) {
		this.page.showWidgetInstance(widgetInstance);
	}

	onEdit(widgetInstance: WidgetInstance) {
		this.page.editWidget(widgetInstance);
		this.page.trackWidgetInstanceTelemetry(`Widget Configure clicked`, widgetInstance, {
			sender: 'panel',
		});
	}

	onHide(widgetInstance: WidgetInstance) {
		this.page.hideWidgetInstance(widgetInstance);
		this.page.trackWidgetInstanceTelemetry(`Widget made hidden`, widgetInstance, {
			sender: 'panel',
		});
	}

	onMouseOn(widgetInstance: WidgetInstance) {
		if (widgetInstance.hidden) {
			return;
		}
		if (this.highlightTimer !== null) {
			this.$timeout.cancel(this.highlightTimer);
		}
		this.highlightTimer = this.$timeout(() => {
			this.page.highlightWidgetInstance(widgetInstance);
		}, 1000);
	}

	onMouseLeave() {
		if (this.highlightTimer !== null) {
			this.$timeout.cancel(this.highlightTimer);
			this.highlightTimer = null;
		}
		this.page.hideHighlight();
	}

	onAddNewWidgetClick() {
		this.page.addEmptyWidgetInstance();
	}
}

export const DashboardConfigurationPanelComponent = {
	name: 'mxDashboardConfigurationPanel',
	controller: DashboardConfigurationPanelController,
	controllerAs: 'vm',
	template,
	require: {
		page: `^${DashboardPageComponent.name}`,
	},
};
